import { useCallback, useId } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import BodyText from 'LuxKit/Typography/BodyText'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import { MaldivesFnfSpecialOfferLabel } from 'components/MaldivesDirect/MaldivesDirectSearchPage/MaldivesDirectCalendar/MaldivesFnfSpecialOffer'

const ToggleLabel = styled.label`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: ${rem(8)};
  cursor: pointer;
  white-space: nowrap;
`

interface Props {
  checked: boolean
  onChange: (checked: boolean) => void
}

/**
 * Checkbox that limits the Maldives charter calendar to dates carrying an Infinite
 * Member (Friends & Family) fare. Rendered only for Infinite-tier members alongside
 * the price-mode control (see CharterBundleCalendarActions on mobile,
 * MaldivesDirectSearchFlightCalendar on desktop).
 */
function MaldivesCharterInfiniteMemberPriceToggle({ checked, onChange }: Props) {
  const intl = useIntl()
  const checkboxId = useId()

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }, [onChange])

  const onlyShowLabel = intl.formatMessage({
    id: '4VWDF0wwZSFo-sN4UbsU',
    defaultMessage: 'Only show',
  })
  const ariaLabel = intl.formatMessage({
    id: 'wX3fbgsNSe0ymWoaJh9T',
    defaultMessage: 'Only show Infinite Member Price fares',
  })

  return (
    <ToggleLabel htmlFor={checkboxId}>
      <CheckboxButton
        id={checkboxId}
        size="medium"
        checked={checked}
        onChange={handleChange}
        aria-label={ariaLabel}
      />
      <BodyText variant="small" wrap="no-wrap">{onlyShowLabel}</BodyText>
      <MaldivesFnfSpecialOfferLabel isInfiniteMember />
    </ToggleLabel>
  )
}

export default MaldivesCharterInfiniteMemberPriceToggle
